import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listAppointments } from "../../Redux/actions/patientActions/appointmentActions.js";
import Loading from "../../components/Loading.jsx";
import Error from "../../components/Error.jsx";
import "../../App.css";
import { printAppointmentSlip } from "../../components/adminComponents/Appointments/PrintAppointmentSlip.js";

const MyAppointmentsScreen = () => {
  const dispatch = useDispatch();
  const { loading, error, appointments } = useSelector(
    (state) => state.patientAppointments
  );
  // Convert time to 12-hour format
const formatTime12Hour = (time24) => {
  if (!time24) return "-";
  const [hours, minutes] = time24.split(":");
  const hour = parseInt(hours, 10);
  const ampm = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minutes} ${ampm}`;
};
  const { userInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    if (userInfo) dispatch(listAppointments());
  }, [dispatch, userInfo]);

  return (
    <div className="appointment-container">
      <div className="appointment-card">
        {/* <h2 className="appointment-title text-center mb-4">My Appointments</h2> */}

        {loading && <Loading />}
        {error && <Error message={error} />}

        <div className="table-responsive">
          <table className="table table-hover align-middle">
            <thead className="table-teal">
              <tr>
                <th>Patient</th>
                <th>Father Name</th>
                <th>Department</th>
                <th>Number</th>
                <th>Date</th>
                <th>Time</th>
                <th>Doctor</th>
                <th>Status</th>
                <th>Print</th>
              </tr>
            </thead>
            <tbody>
              {appointments && appointments.length > 0 ? (
                appointments.map((appt) => (
                  <tr key={appt._id}>
                    <td>{appt.pName}</td>
                    <td>{appt.fatherName}</td>
                    <td>{appt.department}</td>
                    <td>{appt.appointmentNumber || "-"}</td>
                    <td>
                      {appt.date
                        ? new Date(appt.date).toLocaleDateString()
                        : "-"}
                    </td>
                    <td>{formatTime12Hour(appt.time) || "-"}</td>
                    <td>{appt.doctor ? appt.doctor.name : "-"}</td>
                    <td>
                      <span
                        className={`badge ${
                          appt.status === "completed"
                            ? "badge-success"
                            : appt.status === "rejected"
                            ? "badge-danger"
                            : "badge-warning"
                        }`}
                      >
                        {appt.status
                          ? appt.status.charAt(0).toUpperCase() +
                            appt.status.slice(1)
                          : "-"}
                      </span>
                    </td>
                    <td>
                      {appt.status?.toLowerCase() === "confirmed" && (
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => printAppointmentSlip(appt)}
                        >
                          Print
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-muted py-4">
                    No appointments found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MyAppointmentsScreen;
